/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { ProductServoPipelineResultDto } from '../model/product-servo-pipeline-result-dto.model';
// @ts-ignore
import { PublicServoElektronikContractCreateDto } from '../model/public-servo-elektronik-contract-create-dto.model';
// @ts-ignore
import { ServoElektronikVersicherungspraemieCalcDto } from '../model/servo-elektronik-versicherungspraemie-calc-dto.model';
// @ts-ignore
import { VersicherungspraemieCalculationResultDto } from '../model/versicherungspraemie-calculation-result-dto.model';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class PublicServoElektronikApiService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * @endpoint post /api/public-servo-elektronik/contract/elektronik
     * @param publicServoElektronikContractCreateDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPublicServoElektronikContractElektronikPost(publicServoElektronikContractCreateDto: PublicServoElektronikContractCreateDto, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ProductServoPipelineResultDto>;
    public apiPublicServoElektronikContractElektronikPost(publicServoElektronikContractCreateDto: PublicServoElektronikContractCreateDto, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ProductServoPipelineResultDto>>;
    public apiPublicServoElektronikContractElektronikPost(publicServoElektronikContractCreateDto: PublicServoElektronikContractCreateDto, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ProductServoPipelineResultDto>>;
    public apiPublicServoElektronikContractElektronikPost(publicServoElektronikContractCreateDto: PublicServoElektronikContractCreateDto, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (publicServoElektronikContractCreateDto === null || publicServoElektronikContractCreateDto === undefined) {
            throw new Error('Required parameter publicServoElektronikContractCreateDto was null or undefined when calling apiPublicServoElektronikContractElektronikPost.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/public-servo-elektronik/contract/elektronik`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ProductServoPipelineResultDto>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: publicServoElektronikContractCreateDto,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint post /api/public-servo-elektronik/contract/elektronik/versicherungspraemie
     * @param servoElektronikVersicherungspraemieCalcDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPublicServoElektronikContractElektronikVersicherungspraemiePost(servoElektronikVersicherungspraemieCalcDto: ServoElektronikVersicherungspraemieCalcDto, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<VersicherungspraemieCalculationResultDto>;
    public apiPublicServoElektronikContractElektronikVersicherungspraemiePost(servoElektronikVersicherungspraemieCalcDto: ServoElektronikVersicherungspraemieCalcDto, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VersicherungspraemieCalculationResultDto>>;
    public apiPublicServoElektronikContractElektronikVersicherungspraemiePost(servoElektronikVersicherungspraemieCalcDto: ServoElektronikVersicherungspraemieCalcDto, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VersicherungspraemieCalculationResultDto>>;
    public apiPublicServoElektronikContractElektronikVersicherungspraemiePost(servoElektronikVersicherungspraemieCalcDto: ServoElektronikVersicherungspraemieCalcDto, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (servoElektronikVersicherungspraemieCalcDto === null || servoElektronikVersicherungspraemieCalcDto === undefined) {
            throw new Error('Required parameter servoElektronikVersicherungspraemieCalcDto was null or undefined when calling apiPublicServoElektronikContractElektronikVersicherungspraemiePost.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/public-servo-elektronik/contract/elektronik/versicherungspraemie`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<VersicherungspraemieCalculationResultDto>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: servoElektronikVersicherungspraemieCalcDto,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
